"use strict";Object.defineProperty(exports, "__esModule", {value: true});var p=(e=2)=>t=>typeof e=="function"?e(t):`${e*t}px`,n= exports.a =p;exports.a = n;
